import { render, staticRenderFns } from "./BucketTable.vue?vue&type=template&id=3ac03608"
import script from "./BucketTable.vue?vue&type=script&lang=js"
export * from "./BucketTable.vue?vue&type=script&lang=js"
import style0 from "./BucketTable.vue?vue&type=style&index=0&id=3ac03608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports